import { forwardRef } from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";
import { Button, Text } from "@radix-ui/themes";

import "react-datepicker/dist/react-datepicker.css";
import "./date-time-picker.css";

interface CustomButtonProps {
  value?: string;
  onClick?: () => void;
}

const CustomButton = forwardRef<HTMLButtonElement, CustomButtonProps>(
  ({ value, onClick }, ref) => (
    <Button
      size="2"
      variant="soft"
      color="gray"
      className="w-full"
      onClick={onClick}
      ref={ref}
    >
      <Text size="1" mr={value && "4"}>
        {value ? `${value}` : "Set date and time"}{" "}
      </Text>
    </Button>
  )
);

CustomButton.displayName = "CustomButton";

interface CustomDatePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
}

const CustomDatePicker = ({ selected, onChange }: CustomDatePickerProps) => {
  return (
    <DatePicker
      isClearable
      portalId="root"
      selected={selected}
      onChange={onChange}
      showTimeSelect
      wrapperClassName="custom-date-picker-input-wrapper"
      calendarClassName="custom-date-picker"
      dateFormat="HH:mm MMMM d, yyyy"
      timeFormat="HH:mm"
      timeIntervals={30}
      popperPlacement="bottom-start"
      customInput={<CustomButton />}
      calendarContainer={({ className, children }) => {
        return (
          <div
            onWheel={(e) => {
              // A fix for the issue with the time selection container not being able to scroll https://github.com/radix-ui/primitives/issues/1159
              e.stopPropagation();
            }}
          >
            <CalendarContainer className={className}>
              {children}
            </CalendarContainer>
          </div>
        );
      }}
    />
  );
};

export default CustomDatePicker;
